export enum AppRoutes {
	LINKED_ACCOUNTS = "/account/linked-accounts",
	VENDOR_ACCOUNTS = "/account/vendor-accounts",
	DISPLAY_PREFERENCES = "/account/display-preferences",
	END_OF_REGISTRATION = "/account/end-of-registration",
	LOGIN = "/account/sign-in",
	PROFILE = "/account/my-profile",
	ACCOUNT_DATA_PROFILE = "/account/my-profile/company-info",
	DISPLAY_PREFERENCES_PROFILE = "/account/my-profile/display-preferences",
	LINKED_ACCOUNTS_PROFILE = "/account/my-profile/linked-accounts",
	TRANSFER_ACCOUNT_PROFILE = "/account/my-profile/transfer-account",
	RESET_PASSWORD_PROFILE = "/account/my-profile/reset-password",
	BASE = "/",
	REGISTER_CREDENTIALS = "/account/register",
	ACCOUNT_DATA = "/account/account-data",
	EMAIL_INPUT_FORGOT_PASSWORD = "/account/forgot-password-request",
	ERROR = "/error",
	NOT_FOUND = "/not-found",
	MANAGE_ITEMS = "/manage-items",
	REGISTRATION_LINK_ALREADY_USED = "/register-link-used",
	ADMIN_DASHBOARD = "/admin/administration",
	SUPPLIER_INFO = "/admin/administration/supplier-info",
	VENDOR_INFO = "/admin/administration/vendor-info",
	TRANSFER_ACCOUNT = "/admin/administration/transfer-account",
	SEND_INVITATIONS = "/admin/administration/send-invitation",
	RESET_PASSWORD = "/admin/administration/reset-password",
	USER_MANAGEMENT = "/admin/administration/user-management",
	ADMIN_REGISTRATION = "/admin/admin-registration",
	MANAGE_ALL_ITEMS = "/admin/manage-all-items",
	CUSTOMER_VIEW = "/customer-view",
}
